import { DEFAULT_TRANSLATION, type TranslationCode } from "@versedrill/core";

/**
 * Add the Bible version to a request for verse text. WEB (the default) is left out, so its URLs, and whatever is cached
 * for them, stay exactly as they were; every other version gets `tr=`. Requests that grade or hint never carry one: the
 * game's structure is the same in every version.
 */
export function withVersion(url: string, translation: TranslationCode): string {
  if (translation === DEFAULT_TRANSLATION) return url;
  return `${url}${url.includes("?") ? "&" : "?"}tr=${translation}`;
}
